export default __webpack_public_path__ + "static/media/3.0a04d4d9.jpg";